import { FC } from "react";

/** Simple placeholder component for mock tabs */
export const TabPlaceholder: FC<{ title: string; id: string }> = ({ title, id }) => (
  <div className="flex flex-col items-center justify-center h-full w-full bg-zinc-100 dark:bg-zinc-900 text-zinc-600 dark:text-zinc-400">
    <div className="text-xl font-semibold mb-2">{title}</div>
    <div className="text-sm">Tab ID: {id}</div>
    <div className="text-xs mt-4 text-zinc-400 dark:text-zinc-600">
      Content coming soon...
    </div>
  </div>
);
